export function compileMain(): string {
  return `$main();`;
}
